import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import moment from 'moment'

export default {
  components: {},

  data() {
    return {
      institutionSearch: '',
      filter: {
        page: 1,
        pageSize: 7,
        institutionIds: [],
        unidadeIds: [],
        startDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          1
        )
          .toISOString()
          .substr(0, 7),
        endDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          1
        )
          .toISOString()
          .substr(0, 7),
      },
      filterKey: false,
      apiService: new ApiService(),
      unidades: [],
      institutions: [],
      unidadeLoading: false,
      institutionLoading: false,

      loading: false,
      showChart: true,
      ratings: [],
      expanded: [],
      page: 1,
      total: 0,
      totalPages: 1,
      pageSize: 7,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Instituição',
          align: 'center',
          value: 'instituicao',
        },
        {
          text: 'Nº O.S.',
          align: 'center',
          value: 'serviceOrder',
        },
        {
          text: 'Setor',
          align: 'center',
          value: 'department',
        },
        {
          text: 'Avalia Serviço Concluído',
          align: 'center',
          value: 'rateService',
        },
        {
          text: 'Avalia Ranking',
          align: 'center',
          value: 'rateRanking',
        },
        {
          text: 'Avalia Observação',
          align: 'center',
          value: 'rateObs',
        },
        {
          text: 'Avalia E-mail',
          align: 'center',
          value: 'email',
        },
        {
          text: 'Solicitante',
          align: 'center',
          value: 'requester',
        },
        {
          text: 'Data Fechamento O.S.',
          align: 'center',
          value: 'closeDate',
        },
      ],
      mobileHeader: [
        {
          text: 'Nº O.S.',
          align: 'center',
          value: 'serviceOrder',
        },
        {
          text: 'Avalia Ranking',
          align: 'center',
          value: 'rateRanking',
        },
      ],
      total: 0,
      ratingCounts: {},
    }
  },

  async created() {
    this.getInstitutions()
    this.listRatings()
  },

  computed: {
    likesAll() {
      return this.filter.unidadeIds.length === this.unidades.length
    },
    likesSome() {
      return this.filter.unidadeIds.length > 0 && !this.likesAll
    },
    icon() {
      if (this.likesAll) return 'mdi-close-box'
      if (this.likesSome) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },

  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.unidadeIds = []
        } else {
          this.filter.unidadeIds = this.unidades.slice()
        }
      })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/list')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch((err) => {})
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .post(`unidade/listByIntitutionIds`, {
          ids: this.filter.institutionIds,
        })
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    setDates() {
      const startYear = this.startDate.split('-')[0]
      const startMonth = this.startDate.split('-')[1]
      const endYear = this.endDate.split('-')[0]
      const endMonth = this.endDate.split('-')[1]

      this.filter.startDate = moment(
        startYear + '-' + startMonth + '-' + 1
      ).format('yyyy-MM-DD')
      this.filter.endDate = moment(new Date(endYear, endMonth, 0)).format(
        'yyyy-MM-DD'
      )
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: 25,
        institutionIds: [],
        unidadeIds: [],
      }
      this.listRatings()
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    async listRatings() {
      this.loading = true
      await this.apiService
        .post('bigData/ratingServiceOrder', this.filter)
        .then((response) => {
          this.total = response.content.paginated.pager.totalItems
          this.totalPages = response.content.paginated.pager.totalPages
          this.showChart = response.content.paginated.objects.length > 0
          this.ratings = response.content.paginated.objects
          this.ratingCounts = {
            high: response.content.highRating,
            well: response.content.wellRating,
            regular: response.content.regularRating,
            bad: response.content.badRating,
          }
        })
        .catch((err) => {})
      this.loading = false
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.listRatings()
    },
  },
}
